import produce from 'immer';
import { hasChildren } from '../../../widgets/repository/containers/hasChildren.ts';
import {
  type IRootWidget,
  isRoot,
} from '../../../widgets/repository/containers/root/IRootWidget.ts';
import { WidgetRepository } from '../../../widgets/repository/WidgetRepository.ts';
import { type WidgetOrRoot } from '../../../widgets/Widget.ts';

/**
 * Crea la rappresentazione materializzata dell'albero, ovvero con i `children`
 * effettivamente presenti.
 * È il caso di un `TableInput` che crea fisicamente gli R x C widget (prodotto
 * cartesiano tra righe e colonne)
 *
 * @param root La root dell'albero
 * @returns La root materializzata
 */
export function createMaterializedTree(root: IRootWidget) {
  return produce<IRootWidget, IRootWidget>(root, draft => {
    const queue: WidgetOrRoot[] = [draft];
    let headIdx = 0;

    while (headIdx < queue.length) {
      const node = queue[headIdx++];
      const materializedChildren = materializeChildren(node);
      if (materializedChildren) {
        if (hasChildren(node)) {
          if (!node.children) node.children = [];
          node.children.push(...materializedChildren);
        }
      }

      if (hasChildren(node) && node.children) queue.push(...node.children);
    }
  });
}

function materializeChildren(widget: WidgetOrRoot) {
  if (isRoot(widget)) return null;

  const type = WidgetRepository.find(widget.type);
  if (type?.materializeChildren) {
    return type.materializeChildren(widget);
  }
}

// export function navigateTreeWithVirtuals(
//   root: IRootWidget,
//   callback: (node: IBaseWidget, parent: IBaseWidget | null) => void
// ) {
//   const materializedRoot = produce(root, draft => {
//     const queue: IBaseWidget[] = [draft];
//     let node: IBaseWidget | undefined;
//     while ((node = queue.shift()) != null) {
//       const materializedChildren = materializeChildren(node);
//       if (materializedChildren) {
//         if (!node.children) node.children = [];
//         node.children.push(...materializedChildren);
//       }
//     }
//   });

//   const queue: TreeTuple[] = [[materializedRoot, null]];
//   let tuple: TreeTuple | undefined;
//   while ((tuple = queue.shift()) != null) {
//     const [node, parent] = tuple;
//     callback(node, parent);

//     queue.push(
//       ...(node.children?.map(child => [child, node] as TreeTuple) ?? [])
//     );
//   }

//   return { materializedRoot };
// }
